import instance from "../../utils/axios";

const API_BASE_URL = "/churches/team/coverimage";

// ✅ Save Team Cover Image
export const saveTeamCoverImageApi = async (payload) => {
  const required = ["memberObjId", "galleryObjId"];
  for (const key of required) {
    if (!payload[key]) throw new Error(`Missing field: ${key}`);
  }

  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([k, v]) => formData.append(k, v ?? ""));

  const response = await instance.post(`${API_BASE_URL}/save`, formData);
  return response.data; // { type, message, data }
};

// ✅ Update Team Cover Image
export const updateTeamCoverImageApi = async (payload) => {
  const required = ["memberObjId", "galleryObjId"];
  for (const key of required) {
    if (!payload[key]) throw new Error(`Missing field: ${key}`);
  }

  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([k, v]) => formData.append(k, v ?? ""));

  const response = await instance.post(`${API_BASE_URL}/update`, formData);
  return response.data;
};
export const deleteTeamCoverImageApi = async (payload) => {
  const required = ["_id", "memberObjId", "memberimageObjId"];
  required.forEach((key) => {
    if (!payload[key]) throw new Error(`Missing field: ${key}`);
  });


  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([k, v]) => formData.append(k, v ?? ""));

  const response = await instance.post(`${API_BASE_URL}/delete`, formData);
  return response.data; // { type, message }
};
